// removed by extract-text-webpack-plugin
module.exports = {"binary_spinner":"h6KvPFzcdzOmVM7iBuLJL","binary_spinner_inline":"xX_ZZbYF8u6nG5d5sDbqu"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/Spinner/Spinner.scss
// module id = 2134
// module chunks = 1